<template>
  <div class="partner">
    <div class="shadow"></div>
    <div class="certificate-list">
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">TRAIN</div>
          <div class="eng-font">师资培训</div>
        </div>
      </div>

      <div class="certificate-list-right">
        <!-- 政策标准 通知公告 用同样的布局和样式 -->
        <div class="titleList" v-if="pindex == 0">
          <div class="title">
            <div
              @click="goLearn(8)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2022年第一期师资培训
            </div>
          </div>

          <div class="title">
            <div
              @click="goLearn(9)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2022年第二期师资培训
            </div>
          </div>
         

          <div class="title">
            <div
              @click="toLearn(2)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2021年第一期垃圾焚烧发电1+X师资培训
            </div>
          </div>
          <div class="title">
            <div
              @click="goLearn(0)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2021年第一期发电集控运维1+X师资培训(660MW超超临界机组)
            </div>
          </div>
          <div class="title">
            <div
              @click="goLearn(1)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2021年第一期发电集控运维1+X师资培训(330MW亚临界机组)
            </div>
          </div>
          <div class="title">
            <div
              @click="goLearn(2)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2021年第一期发电集控运维1+X师资培训(350MW&nbsp;CFB机组)
            </div>
          </div>
          <div class="title">
            <div
              @click="goLearn(3)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2021年第一期发电集控运维1+X师资培训(50MW&nbsp;CFB机组)
            </div>
          </div>

           <div class="title">
            <div
              @click="toLearn(0)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2020年第一期垃圾焚烧发电1+X师资培训
            </div>
          </div>
          <div class="title">
            <div
              @click="toLearn(1)"
              class="title-title"
              style="line-height: 85px; padding-left: 15px"
            >
              2020年第二期垃圾焚烧发电1+X师资培训
            </div>
          </div>

          
        </div>
        <div class="title-page" v-if="pindex == 0">
          <div class="flex">
            <div class="box active">1</div>
          </div>
          <div class="box title-page-active" style="width: 150px">下一页</div>
        </div>
        <div class="title-page" v-if="pindex == 1">
          <div class="flex">
            <div class="box active">1</div>
          </div>
          <div class="box title-page-active" style="width: 150px">下一页</div>
        </div>
        <div class="title-page" v-if="pindex == 2">
          <div class="flex">
            <div class="box active">1</div>
          </div>
          <div class="box title-page-active" style="width: 150px">下一页</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Article,
  ArChildren,
  timestampToTime,
  Serchdata,
} from "../../services/article";
export default {
  data() {
    return {
      barList: [{ name: "2022年" }, { name: "2021年" }, { name: "2020年" }],
      pindex: 0, //一级分类子菜单id-选项卡样式控制参数
      menuList: [
        {
          id: "137",
          name: "政策标准",
          path: "/certificatechildren",
        },
        {
          id: "138",
          name: "通知公告",
          path: "/notice",
        },
        {
          id: "139",
          name: "师资培训",
          path: "/train",
        },
        {
          id: "140",
          name: "教学资源",
          path: "/resource",
        },
        {
          id: "141",
          name: "证书信息",
          path: "/certificateInfo",
        },
        {
          id: "142",
          name: "学分银行",
          path: "/creditbank",
        },
        {
          id: "143",
          name: "信息查询",
          path: "/inqure",
        },
      ],
      titleList: [],
    };
  },
  mounted() {
    this.menuClick(2);
  },
  methods: {
    //一级分类标题点击事件 : 根据pid查询cid
    menuClick(index) {
      this.searchFlag = true;
      this.searchImgUrl = "";
      this.sourceFlag = true;
      this.pageIndex = 1; //初始化页码
      this.activeName = index; //改变选项卡样式
      this.pindex = 0; //改变二级菜单样式
      //console.log(index, this.menuList, "一级分类标题点击事件");
      // 学分银行不执行
      if (index == 5 || index == 4 || index == 6) {
        this.dataList = [];
        return;
      }
      //师资培训 直接查询文章
      // if(index==2){
      // 	this.videoIndex=0;//video-mini-list开始下标
      // 	this.playIndex=0;//video-main所显示播放列表中的视频内容
      // 	this.videoFlag=true;
      // 	let cid = this.menuList[index].id;
      // 	this.article(cid,1);
      // }else{
      let dataList = [];
      this.dataList = [];
      let pid = this.menuList[index].id;
      //console.log(this.menuList, "res1");
      //获取二级分类
      ArChildren({
        pid: pid,
      }).then((res1) => {
        //console.log(res1, "res1");
        if (res1.items.length > 0) {
          this.dataList = [];
          res1.items.forEach((item) => {
            dataList.push(item);
          });
          //这里接口跨域，this.dataList获取不到值
          this.dataList = dataList;
          //console.log(dataList, "dataList");
          let cid = this.dataList[0].id;
          //获取二级分类下的文章列表
          if (index != 2) {
            this.article(cid, 1);
          }
        }
      });

      // }
    },
    categoryChange(index) {
      //根据tab页面切换，展示不同页面
      this.pindex = index;

      //console.log(index, `tab切换，现在切换到${index}`);
    },

    toLearn(index) {
      localStorage.setItem("index", index);
      localStorage.setItem("active", 2);
      localStorage.setItem("pIndex", 0);
      // window.open(this.$router.resolve({name: 'learn'}).href,'_blank')
      if (index == 0) {
        this.$router.push({
          path: "/learn",
        });
      } else if (index == 1) {
        this.$router.push({
          path: "/learn2",
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/learn3",
        });
      }
    },
    goLearn(index) {
      localStorage.setItem("index", index);
      localStorage.setItem("active", 2);
      localStorage.setItem("pIndex", 0);
      // window.open(this.$router.resolve({name: 'learn'}).href,'_blank')
      if (index == 0) {
        this.$router.push({
          path: "/learn4",
        });
      } else if (index == 1) {
        this.$router.push({
          path: "/learn5",
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/learn6",
        });
      } else if (index == 3) {
        this.$router.push({
          path: "/learn7",
        });
      } else if (index == 8) {
        this.$router.push({
          path: "/learn8",
        });
      } else if (index == 9) {
        this.$router.push({
          path: "/learn9",
        });
      }
    },
  },
};
</script>

<style scoped>
.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}
.partner {
  background-color: white;
}
.shadow {
  height: 100px;
  width: 100%;
  background-color: #d7d7d7;
}
.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}

.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
.title-page {
  display: flex;
  justify-content: space-between;
  width: auto;
  padding: 0px 20px 0px 75px;
  margin: 90px 0px 110px;
}
.column1 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column2 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  color: #0055d3;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}

.column1:hover,
.column2:hover {
  color: #0055d3;
  cursor: pointer;
}
</style>
